import { useDispatch } from "react-redux";
import contractActions from "@/components/Contracts/actions/newActions"
import { default as couponService } from "@/components/form-fields/CouponField/services/coupons";
import { UseCouponProps } from "@/components/form-fields/CouponField/hooks/useCoupon";

const electricityActions = contractActions["electricity"];

const useContractCoupon = ({
  association,
  type,
}: UseCouponProps) => {
  const dispatch = useDispatch();

  const handleApplyCoupon = (
    coupon: string
  ) => {
    dispatch(electricityActions.couponFormSubmited());

    couponService.applyCoupon({coupon, association})
    .then(res => {
      dispatch(electricityActions.couponFormSuccessed(res));
    })
    .catch(err => {
      // dispatch(electricityActions.couponFormSuccessed({
      //   code: coupon,
      //   description: "",
      //   createDate: "Today"
      // }));
      dispatch(electricityActions.couponFormFailed());
      
      // if (axios.isAxiosError<INoCessionSIPSErrorsResponse>(err))  {
      //   if (err.response?.status === 400) {
      //     setErrors(err.response?.data.errors);
      //   }
      // }
    })
  };

  return {
    handleApplyCoupon
  }

}

export default useContractCoupon;